/* Exotic Blvd :: global behaviour (global lane, batch 4, 2026-10-24)
   R11: the phone menu (Turbo MobileMenuDrawer on details[data-mobile-menu]) closes on Escape and
   hands focus back to the MENU toggle; while it is open, Tab and Shift+Tab stay inside the menu.
   Uses the theme's own window.mobileMenuDrawer.close() so the body class and animation stay in sync. */
(function () {
  'use strict';
  if (window.ebGlobalMenuKeys) { return; }
  window.ebGlobalMenuKeys = true;

  function menuEl() { return document.querySelector('details[data-mobile-menu]'); }

  function isOpen(el) {
    if (!el) { return false; }
    var drawer = window.mobileMenuDrawer;
    if (drawer && drawer.animation && drawer.animation.state) { return drawer.animation.state === 'open'; }
    return el.open === true;
  }

  function focusables(el) {
    var panel = el.querySelector('[data-nav]');
    var trigger = el.querySelector('[data-mobile-menu-trigger]');
    var list = [];
    if (trigger) { list.push(trigger); }
    if (panel) {
      var nodes = panel.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, summary, [tabindex]:not([tabindex="-1"])');
      for (var i = 0; i < nodes.length; i++) {
        var n = nodes[i];
        if (n.offsetWidth > 0 || n.offsetHeight > 0 || n.getClientRects().length) { list.push(n); }
      }
    }
    return list;
  }

  function close(el) {
    var trigger = el.querySelector('[data-mobile-menu-trigger]');
    if (window.mobileMenuDrawer && typeof window.mobileMenuDrawer.close === 'function') {
      window.mobileMenuDrawer.close();
    } else {
      el.open = false;
      document.body.classList.remove('is-active');
    }
    if (trigger) { trigger.focus(); }
  }

  /* R10: Turbo prepends its desktop sticky-nav clone to <body> after load, which pushes the skip
     link down the tab order. Keep the skip link as the first child of <body>.
     S16: that clone also copies the mini cart payment icons, so their svg ids repeat. Give every
     copy after the first its own ids (and the matching aria-labelledby and url(#...) references). */
  function tidy() {
    var skip = document.querySelector('a.eb-skip-link');
    if (skip && document.body && document.body.firstElementChild !== skip) {
      document.body.insertBefore(skip, document.body.firstChild);
    }
    var seen = {};
    var svgs = document.querySelectorAll('svg');
    for (var i = 0; i < svgs.length; i++) {
      var svg = svgs[i];
      var idEls = svg.querySelectorAll('[id*="-pi-"]');
      if (!idEls.length) { continue; }
      var first = idEls[0].id;
      if (!seen[first]) { seen[first] = 1; continue; }
      seen[first] += 1;
      var suffix = '-c' + seen[first];
      var html = svg.innerHTML;
      var attrs = ['aria-labelledby'];
      for (var k = 0; k < idEls.length; k++) {
        var oldId = idEls[k].id;
        var newId = oldId + suffix;
        html = html.split('"' + oldId + '"').join('"' + newId + '"').split('#' + oldId + ')').join('#' + newId + ')');
        for (var a = 0; a < attrs.length; a++) {
          if (svg.getAttribute(attrs[a]) === oldId) { svg.setAttribute(attrs[a], newId); }
        }
      }
      svg.innerHTML = html;
    }
  }
  if (document.readyState === 'complete') { tidy(); } else { window.addEventListener('load', tidy); }

  /* Q3 (batch 5, megamenu lane): Turbo opens the country/language selectors on focus
     (utilities.js enableDisclosure, 'mouseenter focus'), so keyboard users had to Tab through the
     whole country list before the nav. Keep hover-open for the mouse, but a keyboard user now opens
     the list with Enter or Space (a button click) and Tab moves past a closed selector. */
  function fixDisclosures() {
    var $ = window.jQuery;
    var toggles = document.querySelectorAll('[data-disclosure-toggle]');
    if (!toggles.length) { return; }
    if ($) { $(toggles).off('focus'); }
    function setOpen(t, open) {
      t.classList.toggle('is-clicked', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    for (var i = 0; i < toggles.length; i++) {
      (function (t) {
        if (t.getAttribute('data-eb-disclosure')) { return; }
        t.setAttribute('data-eb-disclosure', '1');
        t.addEventListener('click', function (e) {
          if (e.detail !== 0) { return; } /* mouse clicks keep Turbo's hover behaviour */
          setOpen(t, !t.classList.contains('is-clicked'));
        });
        var wrap = t.closest('[data-disclosure]');
        if (wrap) {
          wrap.addEventListener('focusout', function (e) {
            if (!e.relatedTarget || !wrap.contains(e.relatedTarget)) { setOpen(t, false); }
          });
        }
      })(toggles[i]);
    }
  }
  if (document.readyState === 'complete') { fixDisclosures(); } else { window.addEventListener('load', fixDisclosures); }
  window.setTimeout(tidy, 2500);

  document.addEventListener('keydown', function (e) {
    var el = menuEl();
    if (!isOpen(el)) { return; }
    if (e.key === 'Escape' || e.key === 'Esc') {
      e.preventDefault();
      close(el);
      return;
    }
    if (e.key === 'Tab') {
      var items = focusables(el);
      if (!items.length) { return; }
      var first = items[0];
      var last = items[items.length - 1];
      var active = document.activeElement;
      var inside = el.contains(active);
      if (e.shiftKey && (active === first || !inside)) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && (active === last || !inside)) {
        e.preventDefault();
        first.focus();
      }
    }
  });
})();
